import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { SearchProvider } from './context/search-context';
import { SearchComponent } from './search-component';

export function SearchFactory() {
  return (
    <BaseLayoutFactory>
      <SearchProvider>
        <SearchComponent />
      </SearchProvider>
    </BaseLayoutFactory>
  );
}
